<template>
  <div>
    <div class="resourceServiceOperationReport-title">
      <div>{{$t('resourceLifecycle.resourceServiceOperationsReport')}}</div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t( 'resourceLifecycle.resourcepricefactorconfiguration' )">
          <div class="resourceServiceOperationReport-top">
            <resource-price-coefficient-search></resource-price-coefficient-search>
          </div>
          <table-resource-price-coefficient></table-resource-price-coefficient>
        </TabPane>
        <TabPane :label="$t( 'resourceLifecycle.resourceServiceOperationsReport' )">
          <operation-report></operation-report>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
  import OperationReport from '../resource_service_operation_report/operation_report/OperationReport'
  import ResourcePriceCoefficientSearch from '../resource_service_operation_report/resource_price_coefficient/ResourcePriceCoefficientSearch'
  import TableResourcePriceCoefficient from '../resource_service_operation_report/resource_price_coefficient/TableResourcePriceCoefficient'

  export default {
    name: 'ResourceServiceOperationReport',
    components: {
      OperationReport,
      ResourcePriceCoefficientSearch,
      TableResourcePriceCoefficient
    }
  }
</script>

<style scoped>
  .resourceServiceOperationReport-title
  {
    width: 100%;
    font-size: 13px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px 0px 8px 4px;
    font-weight: 600;
    overflow: hidden;
  }
  .resourceServiceOperationReport-title>div:nth-child(1)
  {
    float:left;
  }
  .resourceServiceOperationReport-top
  {
    width: 100%;
    height: 32px;
    margin-bottom: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_service_operation_report/ResourceServiceOperationReport.vue